<template>
  <div class="container">
    <CCard class="shadow border" :style="{ borderRadius: '20px', boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)' }">
      <CCardBody>
        <div class="text-center mb-4 mt-4">
          <h4 class="fw-bold">President of the Student Association Candidate Register</h4>
          <p class="mb-1">Upload JPG Image</p>
          <small class="text-danger fw-semibold">*1080x1080 px</small>
        </div>

        <CForm>
          <!-- Profile Upload -->
          <CRow class="align-items-center mb-4">
            <CCol md="12" class="text-center mb-3">
              <img v-if="profilePreview" :src="profilePreview" alt="Profile Preview" class="img-thumbnail d-block mx-auto" style="max-height: 200px; object-fit: contain;" />
              <div class="text-danger mt-1" v-if="errors.profile">Profile image is required.</div>
            </CCol>
            <CCol md="9">
              <input type="text" class="form-control" placeholder="Profile Image File" :value="profileFileName" disabled />
            </CCol>
            <CCol md="3">
              <input type="file" ref="profileInput" class="d-none" accept="image/jpeg,image/png" @change="handleProfileSelect" />
              <button type="button" class="btn btn-outline-primary w-100" @click="triggerProfileUpload">Choose File</button>
            </CCol>
          </CRow>

          <!-- Form Fields -->
          <CRow class="mb-4">
            <CCol md="6" class="mb-3">
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.name }" placeholder="Name" v-model="form.name" disabled />
            </CCol>
            <CCol md="6" class="mb-3">
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.studentID }" placeholder="Student ID" v-model="form.studentID" />
            </CCol>

            <!-- Editable Department Dropdown -->
            <CCol md="6" class="mb-3">
              <select class="form-control" v-model="form.department" :class="{ 'is-invalid': errors.department }">
                <option disabled value="">Select School</option>
                <option v-for="dept in departments" :key="dept._id" :value="dept._id">
                  {{ dept.department_name }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.department">Please select a school</div>
            </CCol>

            <!-- Dynamic Major Dropdown -->
            <CCol md="6" class="mb-3">
              <select class="form-control" v-model="form.major" :class="{ 'is-invalid': errors.major }">
                <option disabled value="">Select Major</option>
                <option v-for="m in filteredMajors" :key="m._id" :value="m._id">{{ m.major_name }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.major">Please select a major</div>
            </CCol>
            <!-- Line -->
            <CCol md="6" class="mb-3">
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.line }" placeholder="Line ID" v-model="form.line" />
              <div class="invalid-feedback" v-if="errors.line">{{ errors.line }}</div>
            </CCol>

            <!-- GPA Type -->
            <CCol md="6" class="mb-3">
              <select class="form-control" :class="{ 'is-invalid': errors.gpaxtype }" v-model="form.gpaxtype">
                <option disabled value="">Select GPA Type</option>
                <option v-for="type in gpaxtypes" :key="type._id" :value="type._id">{{ type.gpaxtype_name }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.gpaxtype">{{ errors.gpaxtype }}</div>
            </CCol>

            <CCol md="6" class="mb-3">
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.gpax }" placeholder="GPAX" v-model="form.gpax" />
              <div class="invalid-feedback" v-if="errors.gpax">{{ errors.gpax }}</div>
            </CCol>

            <!-- Transcript Upload -->
            <CCol md="6">
              <CRow class="align-items-center">
                <CCol md="8">
                  <input type="text" class="form-control" placeholder="Transcript File" :value="transcriptFileName" disabled />
                </CCol>
                <CCol md="4">
                  <input type="file" ref="transcriptInput" class="d-none" accept="image/jpeg,image/png" @change="handleTranscriptSelect" />
                  <button type="button" class="btn btn-outline-primary w-100" @click="triggerTranscriptUpload">Choose File</button>
                </CCol>
                <CCol md="12" class="text-center mt-2">
                  <img v-if="transcriptPreview" :src="transcriptPreview" alt="Transcript Preview" class="img-thumbnail" style="max-height: 200px; object-fit: contain;" />
                  <div class="text-danger mt-1" v-if="errors.transcript">Transcript image is required.</div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>

          <!-- Policy -->
          <CCardHeader class="fw-bold fs-5 mt-4">
            <h4>Write your policy here</h4>
          </CCardHeader>
          <CCardBody>
            <quill-editor v-model="form.policy" :options="editorOptions" :class="{ 'is-invalid': errors.policy }" style="min-height: 200px" />
            <div class="text-danger mt-1" v-if="errors.policy">{{ errors.policy }}</div>
          </CCardBody>

          <div class="text-center mb-4">
            <CButton
                color="danger"
                size="lg"
                shape="pill"
                @click="submitForm"
                :disabled="isSubmitting || isAlreadyCandidate"
            >
              {{ isSubmitting ? 'Submitting...' : 'Submit' }}
            </CButton>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import api from '@/service/api.js'
import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import Swal from 'sweetalert2'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import _ from 'lodash'

Vue.use(VueQuillEditor)

export default {
  name: 'register_normal',
  data() {
    return {
      profileFileName: '',
      transcriptFileName: '',
      profileFile: null,
      transcriptFile: null,
      profilePreview: '',
      gpaxtypes: [],
      departments: [],
      allMajors: [],
      filteredMajors: [],
      schoolLabel: '',
      isSubmitting: false,
      isAlreadyCandidate: false,
      form: {
        name: '',
        studentID: '',
        department: '',
        major: '',
        line: '',
        gpax: '',
        gpaxtype: '',
        policy: '',
        accountID: '',
        type: '',
        event: '',
        year: new Date().getFullYear(),
        status: '685d14872435685988f5f22c'
      },
      errors: {},
      editorOptions: {
        placeholder: 'Type your policy here...',
        theme: 'snow'
      },
      departmentMajorMap: {
        "School of Applied Digital Technology": ["major3", "major4", "major5", "major6"],
        "School of Agro-Industry": ["major1", "major2"],
        "School of Cosmetic Science": ["major8", "major9"],
        "School of Health Science": ["major10", "major11", "major12"],
        "School of Integrative Medicine": ["major13", "major14", "major15", "major16"],
        "School of Law": ["major17", "major18"],
        "School of Liberal Arts": ["major19", "major20"],
        "School of Management": ["major21", "major22", "major23"],
        "School of Nursing": ["major25"],
        "School of Science": ["major26", "major27", "major28"],
        "School of Sinology": ["major29", "major30", "major31", "major32"],
        "School of Social Innovation": ["major33"],
        "School of Dentistry": ["major10"]
      }
    }
  },
  watch: {
    'form.studentID': _.debounce(async function (val) {
      if (!val) return;
      try {
        const res = await api.members('post', { studentID: val });
        const user = res?.data?.data;
        if (user) {
          this.form.name = user.name || '';
          this.form.department = user.department?._id || '';
          this.form.major = user.major?._id || '';
          this.form.accountID = user._id || '';

          // ✅ ตรวจสอบว่าเป็น candidate ไหม
          if (user.role === '685e405ae9f2fe21e0c6d02f') {
            this.isAlreadyCandidate = true;
            Swal.fire('Already Registered', 'This student is already a candidate.', 'warning');
          } else {
            this.isAlreadyCandidate = false;
          }
        }
      } catch (err) {
        this.isAlreadyCandidate = false;
      }
    }, 500),

    'form.department'(val) {
      this.form.major = ''
      const department = this.departments.find(d => d._id === val)
      const departmentName = department?.department_name
      const allowedMajorCodes = this.departmentMajorMap[departmentName] || []
      this.filteredMajors = this.allMajors.filter(m => allowedMajorCodes.includes(m.major_code))
    }
  },
  async mounted() {
    this.loadGpaxtypes()
    this.loadDepartments()
    this.loadMajors()
    this.loadRegisterEvent()
    this.loadCandidateType()
  },
  methods: {
    async loadGpaxtypes() {
      const res = await api.gpax('get')
      this.gpaxtypes = res.data.data || []
    },
    async loadDepartments() {
      const res = await api.department('get')
      this.departments = res.data.data || []
    },
    async loadMajors() {
      const res = await api.major('get')
      this.allMajors = res.data.data || []
    },
    async loadRegisterEvent() {
      const res = await api.event('get')
      const ev = res.data.data.find(e => e.event_name === 'Information')
      if (ev) this.form.event = ev._id
    },
    async loadCandidateType() {
      const res = await api.type('get')
      const type = res.data.data.find(t => t.type_name.includes('President of Student Association'))
      if (type) this.form.type = type._id
    },
    triggerProfileUpload() {
      this.$refs.profileInput.click()
    },
    handleProfileSelect(e) {
      const file = e.target.files[0]
      this.profileFile = file
      this.profileFileName = file.name
      this.profilePreview = URL.createObjectURL(file)
    },
    triggerTranscriptUpload() {
      this.$refs.transcriptInput.click()
    },
    handleTranscriptSelect(e) {
      const file = e.target.files[0]
      this.transcriptFile = file
      this.transcriptFileName = file.name
    },
    isFormValid() {
      let valid = true
      this.errors = {}
      const f = this.form
      if (!f.name?.trim()) this.errors.name = 'Name is required', valid = false
      if (!f.studentID?.trim()) this.errors.studentID = 'Student ID is required', valid = false
      if (!f.department?.trim()) this.errors.department = 'Department is required', valid = false
      if (!f.major?.trim()) this.errors.major = 'Major is required', valid = false
      if (!f.line?.trim()) this.errors.line = 'Line ID is required', valid = false
      if (!f.gpax?.trim()) this.errors.gpax = 'GPAX is required', valid = false
      if (!f.gpaxtype?.trim()) this.errors.gpaxtype = 'GPA Type is required', valid = false
      if (!f.policy?.trim()) this.errors.policy = 'Policy is required', valid = false
      if (!this.profileFile) this.errors.profile = 'Profile picture is required', valid = false
      if (!this.transcriptFile) this.errors.transcript = 'Transcript is required', valid = false
      return valid
    },
    async submitForm() {
      if (this.isAlreadyCandidate) {
        Swal.fire('Already Registered', 'This user has already registered as a candidate.', 'warning');
        return;
      }

      if (!this.isFormValid()) {
        Swal.fire('Missing Information', 'Please fill in all required fields.', 'error');
        return;
      }

      this.isSubmitting = true;
      try {
        if (!this.form.accountID) {
          Swal.fire('Error', 'Student account not found or invalid student ID.', 'error');
          this.isSubmitting = false;
          return;
        }

        const payload = {
          ...this.form,
          gpax: parseFloat(this.form.gpax),
        };

        const res = await api.candidate('adminAdd', payload);
        const candidateId = res?.data?.data?._id;

        if (this.profileFile) await this.uploadImage(candidateId, this.profileFile, 'profile');
        if (this.transcriptFile) await this.uploadImage(candidateId, this.transcriptFile, 'transcript');

        // ✅ Update major in account after successful registration
        await api.authenticated('update-major', {
          id: this.form.accountID,
          major: this.form.major
        });

        Swal.fire('Success', 'Your registration has been saved.', 'success')
            .then(() => this.$router.push({ name: 'AdminUserList' }));
      } catch (err) {
        Swal.fire('Error', err?.response?.data?.message || 'Something went wrong', 'error');
      } finally {
        this.isSubmitting = false;
      }
    },

    async uploadImage(candidateId, file, type) {
      const formData = new FormData()
      formData.append('image', file)
      const method = type === 'profile' ? 'uploadCandidatePicture' : 'putCandidateTranscript'
      return api.candidate(method, { id: candidateId, formData })
    }
  }
}
</script>

<style scoped>
.is-invalid {
  border: 1px solid #dc3545 !important;
  border-radius: 0.375rem;
}
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
